import get from 'lodash/get';
import {useNavigate} from 'react-router-dom';

import AppDashboard from '../AppDashboard';
import ProviderSettingsMenu from '../../components/providers/ProviderSettingsMenu';

import {useGetCurrentProviderQuery} from '../../redux/services/providerApi';

const ProviderSettingsPage = props => {
  const navigate = useNavigate();
  const providerQuery = useGetCurrentProviderQuery();
  const childProps = {
    ...props,
    provider: get(providerQuery, 'data'),
    providerId: get(providerQuery, 'data.id'),
  };
  return (
    <AppDashboard title='Settings' hideBack={true} onBack={() => navigate('/providers')}>
      <ProviderSettingsMenu {...childProps} />
    </AppDashboard>
  );
};

export default ProviderSettingsPage;
